/**
 * Centralized Video Configuration
 *
 * UPDATE VIDEO URLS AND METADATA HERE
 * All video references across the site pull from this single source of truth.
 *
 * To update a video:
 * 1. Change the URL in this file
 * 2. Update the uploadDate
 * 3. Update duration if needed
 *
 * That's it! The changes will propagate everywhere automatically.
 */

export const VIDEO_CONFIG = {
  MAIN_ANIMATED_FILM: {
    // Video source
    url: "https://qffeejtjdnsxg9ly.public.blob.vercel-storage.com/16OCT25_FirstCrossing_full_v02.mp4",
    poster: "https://qffeejtjdnsxg9ly.public.blob.vercel-storage.com/AuroraHallowArt/companion_fawn_886x1672.jpg",

    // Metadata
    title: "The First Crossing",
    titleLong: "First Crossing - The Story Begins",
    description: "The first Fawn must decide if she will leave Aurora Hallow and risk her life crossing The Veil to save her home and her human.",
    aspectRatio: "9:16" as const,

    // SEO & Schema.org
    uploadDate: "2025-10-16T00:00:00Z",
    duration: "PT8M44S", // ISO 8601 duration format (8 minutes 44 seconds)
    completionCueSeconds: 341, // 5:41 into The First Crossing

    // Analytics tracking
    urlPattern: "16OCT25_FirstCrossing_full_v02", // Used to identify this video in tracking
    eventName: "animated_film_started",
    clickEventName: "watch_animated_film"
  },

  PRODUCT_ROBOT_FILM: {
    // Video source
    url: "https://qffeejtjdnsxg9ly.public.blob.vercel-storage.com/fawn_ai_companion_robot.mp4",
    poster: undefined, // No poster for this video

    // Metadata
    title: "Fawn AI Companion Robot",
    description: "Fawn is a Living Plushie you can trust with your heart. She listens, talks, moves, and remembers—a best friend through life's ups and downs.",
    aspectRatio: "16:9" as const,

    // SEO & Schema.org
    uploadDate: "2025-09-30",
    duration: "PT55S", // ISO 8601 duration format (55 seconds)

    // Analytics tracking
    urlPattern: "fawn_ai_companion_robot",
    eventName: "product_film_started",
    clickEventName: "watch_product_film"
  },

  ORDER_NOTICE: {
    // Video source
    url: "https://qffeejtjdnsxg9ly.public.blob.vercel-storage.com/videos/Nov18OrdersNotice%20-%20fawn%2Bfox%20-%20no%20crisis.mp4",
    poster: "https://qffeejtjdnsxg9ly.public.blob.vercel-storage.com/AuroraHallowArt/Orders%20Landing%20Page/feather.jpg",

    // Metadata
    title: "Order Notice",
    titleLong: "Call to Order - Your Brief from Aurora",
    description: "You have been identified by the deity Aurora as a key member of our resistance against The Shadow. Watch your briefing to learn about the Four Orders.",
    aspectRatio: "9:16" as const,

    // SEO & Schema.org
    uploadDate: "2025-11-18T00:00:00Z",
    duration: "PT5M44S", // ISO 8601 duration format (5 minutes 44 seconds)

    // Analytics tracking
    urlPattern: "Nov18OrdersNotice",
    eventName: "order_notice_started",
    clickEventName: "watch_order_notice"
  }
} as const;

// Type-safe helper to get video config
export type VideoType = keyof typeof VIDEO_CONFIG;

export function getVideoConfig(type: VideoType) {
  return VIDEO_CONFIG[type];
}
